import { SessionService } from '@core/auth';

/**
 * Who finalizes or begins a planning and therefore follows planning tasks: planners,
 * administrators and the works council, like the backend routes. Employees never do and pay
 * no list request at app start (#5182, PR 1785).
 */
export function canFollowPlanningTasks(
  session: Pick<
    SessionService,
    'isPlanner' | 'isAdministrator' | 'isSuperAdministrator' | 'isBetriebsrat'
  >,
): boolean {
  return !!(
    session.isPlanner ||
    session.isAdministrator ||
    session.isSuperAdministrator ||
    session.isBetriebsrat
  );
}
